import type React from 'react';

import { TagList } from '@xing-com/crate-jobs-domain-serps-components-tag-list';
import { capitalizeFirstLetter } from '@xing-com/crate-jobs-domain-serps-helpers';
import {
  useSeoLinkBoxes,
  useSerpsMatch,
} from '@xing-com/crate-jobs-domain-serps-hooks';

// The FE will control what kind of link boxes can be displayed
const WHITE_LIST: string[] = ['nearby_job_role'];

export const LinkBoxes: React.FC = () => {
  const serps = useSerpsMatch();
  const { data } = useSeoLinkBoxes();

  return (
    <>
      {data?.map((item) => {
        return WHITE_LIST.includes(item.kind) ? (
          <TagList
            key={item.kind}
            headerCopyKey={`XJM_SEO_LINK_BOXES_${item.kind.toLocaleUpperCase()}`}
            headerCopyValues={{
              categoryValue: capitalizeFirstLetter(serps?.categoryValue || ''),
              subcategoryValue: capitalizeFirstLetter(
                serps?.subcategoryValue || ''
              ),
            }}
            serpsList={item.entries}
            showCount="hide"
          />
        ) : null;
      })}
    </>
  );
};
